// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"998":"1628f65f","1187":"40411e7f","4016":"5ff51a03","4181":"1628f65f","5603":"1628f65f"}[chunkId] + ".chunk.css";
};